import { Index } from "../../../Notes";

export const GoTOObligatiobNote = ({ userinfo, dockerValue }) => {
  return (
    <>
      <Index userinfo={userinfo} dockerValue={dockerValue} GoTONotee={true} showchecklist={false}  />
    </>
  );
};
